export const changeFobPriceReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_FOB_PRICE":
        return action.payload.fobPrice;
      default:
        return state;
    }
  };
  